import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class GlobalServiceProvider {
  
  public static OneSignalAppID = "42dd9cf5-6b01-461b-a73e-589269b120e5";
  public static SenderID = "879530731812";
  public static Version = "1.3.0";

  public static FirebaseUser: any = null; //Firebase Auth user
  public static UserInfo = null; //Remote Server info
  public static Token: any;

  public static Games = [];
 
  public static Game = null;

  public static GamesLoaded = false;
  public static FriendsLoaded = false;
  public static JournalsLoaded = false;
  public static HandoutsLoaded = false;
  public static ScenesLoaded = false;

  public static Challenges = []
  public static Journals = [];
  public static Handouts = [];
  public static Scenes = [];
  public static Friends = [];
  public static FriendRequests = [];
  public static Templates = [];

  public static subGame = null;
  public static subMessages = null;
  public static subMoves = null;
  public static subChallenges = null;
  public static subJournals = null;
  public static subHandouts = null;

  public static subNotifications = null;
  public static subScene = null;

  public static InviteNeeded = false;
  public static Live = true;
  

  static isCordovaAvailable = () => {
    if (!(<any>window).cordova) {
      //alert('This is a native feature. Please use a device');
      return false;
    }
    return true;
  };
  static get VerifiedUser(): boolean
  {
    if (this.UserInfo != null) {
      console.log("VERIFIED", this.UserInfo, this.InviteNeeded, this.UserInfo.datejoined);
    }
    return this.UserInfo != null && (!this.InviteNeeded || (this.InviteNeeded && this.UserInfo.datejoined > 0))
  }
  static get Url(): string {

      return this.Live ? "https://www.cloudtabletop.com/" : "http://localhost/cloudtabletop/";

  }
  static get ServiceUrl(): string {

    return this.Live ? "https://www.cloudtabletop.com/api/services/" : "http://localhost/cloudtabletop/api/services/";

  }
  static get ImageUrl(): string {
    return this.Live ? "https://www.cloudtabletop.com/images/" : "http://localhost/cloudtabletop/images/";
  }

  public static Tags = ["Adventure", "Fantasy", "Futuristic", "Historic", "Medieval", "Steampunk", "Horror", "Detective", "Cyberpunk", "Dragons", "Vampires", "Modern", "Dungeons", "Fun", "Roleplaying", "Dystopian"];

  public static getEmojis() {
    const EMOJIS = "😀 😃 😄 😁 😆 😅 😂 🤣 ☺️ 😊 😇 🙂 🙃 😉 😌 😍 😘 😗 😙 😚 😋 😜 😝 😛 🤑 🤗 🤓 😎 🤡 🤠 😏 😒 😞 😔 😟 😕 🙁" +
      " ☹️ 😣 😖 😫 😩 😤 😠 😡 😶 😐 😑 😯 😦 😧 😮 😲 😵 😳 😱 😨 😰 😢 😥 🤤 😭 😓 😪 😴 🙄 🤔 🤥 😬 🤐 🤢 🤧 😷 🤒 🤕 😈 👿" +
      " 👹 👺 💩 👻 💀 ☠️ 👽 👾 🤖 🎃 😺 😸 😹 😻 😼 😽 🙀 😿 😾 👐 🙌 👏 🙏 🤝 👍 👎 👊 ✊ 🤛 🤜 🤞 ✌️ 🤘 👌 👈 👉 👆 👇 ☝️ ✋ 🤚" +
      " 🖐 🖖 👋 🤙 💪 🖕 ✍️ 🤳 💅 🖖 💄 💋 👄 👅 👂 👃 👣 👁 👀 🗣 👤 👥 👶 👦 👧 👨 👩 👱‍♀️ 👱 👴 👵 👲 👳‍♀️ 👳 👮‍♀️ 👮 👷‍♀️ 👷" +
      " 💂‍♀️ 💂 🕵️‍♀️ 🕵️ 👩‍⚕️ 👨‍⚕️ 👩‍🌾 👨‍🌾 👩‍🍳 👨‍🍳 👩‍🎓 👨‍🎓 👩‍🎤 👨‍🎤 👩‍🏫 👨‍🏫 👩‍🏭 👨‍🏭 👩‍💻 👨‍💻 👩‍💼 👨‍💼 👩‍🔧 👨‍🔧 👩‍🔬 👨‍🔬" +
      " 👩‍🎨 👨‍🎨 👩‍🚒 👨‍🚒 👩‍✈️ 👨‍✈️ 👩‍🚀 👨‍🚀 👩‍⚖️ 👨‍⚖️ 🤶 🎅 👸 🤴 👰 🤵 👼 🤰 🙇‍♀️ 🙇 💁 💁‍♂️ 🙅 🙅‍♂️ 🙆 🙆‍♂️ 🙋 🙋‍♂️ 🤦‍♀️ 🤦‍♂️ 🤷‍♀" +
      "️ 🤷‍♂️ 🙎 🙎‍♂️ 🙍 🙍‍♂️ 💇 💇‍♂️ 💆 💆‍♂️ 🕴 💃 🕺 👯 👯‍♂️ 🚶‍♀️ 🚶 🏃‍♀️ 🏃 👫 👭 👬 💑 👩‍❤️‍👩 👨‍❤️‍👨 💏 👩‍❤️‍💋‍👩 👨‍❤️‍💋‍👨 👪 👨‍👩‍👧" +
      " 👨‍👩‍👧‍👦 👨‍👩‍👦‍👦 👨‍👩‍👧‍👧 👩‍👩‍👦 👩‍👩‍👧 👩‍👩‍👧‍👦 👩‍👩‍👦‍👦 👩‍👩‍👧‍👧 👨‍👨‍👦 👨‍👨‍👧 👨‍👨‍👧‍👦 👨‍👨‍👦‍👦 👨‍👨‍👧‍👧 👩‍👦 👩‍👧" +
      " 👩‍👧‍👦 👩‍👦‍👦 👩‍👧‍👧 👨‍👦 👨‍👧 👨‍👧‍👦 👨‍👦‍👦 👨‍👧‍👧 👚 👕 👖 👔 👗 👙 👘 👠 👡 👢 👞 👟 👒 🎩 🎓 👑 ⛑ 🎒 👝 👛 👜 💼 👓" +
      " 🕶 🌂 ☂️";

    const EmojiArr = EMOJIS.split(' ');
    const groupNum = Math.ceil(EmojiArr.length / (24));
    const items = [];

    for (let i = 0; i < groupNum; i++) {
      items.push(EmojiArr.slice(i * 24, (i + 1) * 24));
    }

    console.log(items);
    return items;
  }
  public static initDice() {
    return { sides: "6", setting: "Icons", color: "#f44336", description: "", outcomes: [{ icon: "star", sides: 3, description: "success" }] };
  }
  public static initRoll() {
    return { dice1:[],dice2:[],label:"" };
  }
  public static initRollData() {
    return { dice1: 0, dice2: 0, label: "" };
  }
  public static DiceIcons =
    [
      ["ios-add-circle-outline", "add-circle", "add", "build", "beer", "body"],
    ["remove-circle", "remove", "star", "locate", "water", "sunny"],
    ["snow", "settings", "search", "cloudy", "cloudy-night", "sad"],
    ["cog", "compass", "construct", "cube", "disc", "eye"],
      ["flag", "flame", "flash", "flower", "globe", "hammer"],
      ["ios-alert", "ios-alert-outline", "bonfire", "bug", "bulb", "checkmark"],
      ["arrow-round-back", "arrow-round-down", "arrow-round-forward", "arrow-round-up", "checkmark-circle", "checkmark-circle-outline"],
      ["close", "close-circle", "code", "code-working", "color-wand", "done-all"],
      ["flask", "football", "hand", "heart", "help", "infinite"],
      ["information-circle", "key", "leaf", "log-in", "log-out", "man"],
      ["medical", "menu", "moon", "move", "navigate", "notifications"],
      ["nuclear", "pause", "paw", "pin", "planet", "play"],
      ["power", "pulse", "radio-button-off", "radio-button-on", "rainy", "refresh"],
      ["repeat", "square", "square-outline", "star-half", "star-outline", "sync"],
      ["thumbs-up", "thumbs-down", "trash", "trending-down", "trending-up", "trophy"],
      ["warning", "ios-warning-outline", "ios-warning", "ios-trophy-outline", "ios-trash-outline", "ios-text"],
  ];
  public static DiceSettings = ["Icons", "Numbers"];
  public static DiceMechanics = [
    { id: "icons", name: "Icon Pool", description: "" },
    { id: "dicepooltotal", name: "Dice Pool Total", description: "" },
    { id: "dicepoolsuccess", name: "Dice Pool Successes", description: "" },
    { id: "rolladdstats", name: "Roll add stats", description: "" },
    { id: "rollversusstats", name: "Roll versus stats", description: "" },
    { id: "rollanything", name: "Roll some dice", description: "" }
  ];
  //, , "hand", "heart", ""];
  //public static DiceColors = [["#5AC8FA", "#FFCC00", "#FF9500", "#FF2D55", "#007AFF", "#4CD964", "#FF3B30", "#8E8E93"], ["#1565C0", "#E91E63", "#9C27B0", "#673AB7", "#3F51B5", "#33691E", "#E65100","#424242"]];
  public static DiceColors = [["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#00bcd4", "#009688", "#4caf50"], [ "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#9e9e9e", "#607d8b","#263238"]];
  public static Colors = ["#ffebee",
    "#ffcdd2",
    "#ef9a9a",
    "#e57373",
    "#ef5350",
    "#f44336",
    "#e53935",
    "#d32f2f",
    "#c62828",
    "#b71c1c",
    "#ff8a80",
    "#ff5252",
    "#ff1744",
    "#d50000",
    "#fce4ec",
    "#f8bbd0",
    "#f48fb1",
    "#f06292",
    "#ec407a",
    "#e91e63",
    "#d81b60",
    "#c2185b",
    "#ad1457",
    "#880e4f",
    "#ff80ab",
    "#ff4081",
    "#f50057",
    "#c51162",
    "#f3e5f5",
    "#e1bee7",
    "#ce93d8",
    "#ba68c8",
    "#ab47bc",
    "#9c27b0",
    "#8e24aa",
    "#7b1fa2",
    "#6a1b9a",
    "#4a148c",
    "#ea80fc",
    "#e040fb",
    "#d500f9",
    "#aa00ff",
    "#ede7f6",
    "#d1c4e9",
    "#b39ddb",
    "#9575cd",
    "#7e57c2",
    "#673ab7",
    "#5e35b1",
    "#512da8",
    "#4527a0",
    "#311b92",
    "#b388ff",
    "#7c4dff",
    "#651fff",
    "#6200ea",
    "#e8eaf6",
    "#c5cae9",
    "#9fa8da",
    "#7986cb",
    "#5c6bc0",
    "#3f51b5",
    "#3949ab",
    "#303f9f",
    "#283593",
    "#1a237e",
    "#8c9eff",
    "#536dfe",
    "#3d5afe",
    "#304ffe",
    "#e3f2fd",
    "#bbdefb",
    "#90caf9",
    "#64b5f6",
    "#42a5f5",
    "#2196f3",
    "#1e88e5",
    "#1976d2",
    "#1565c0",
    "#0d47a1",
    "#82b1ff",
    "#448aff",
    "#2979ff",
    "#2962ff",
    "#e1f5fe",
    "#b3e5fc",
    "#81d4fa",
    "#4fc3f7",
    "#29b6f6",
    "#03a9f4",
    "#039be5",
    "#0288d1",
    "#0277bd",
    "#01579b",
    "#80d8ff",
    "#40c4ff",
    "#00b0ff",
    "#0091ea",
    "#e0f7fa",
    "#b2ebf2",
    "#80deea",
    "#4dd0e1",
    "#26c6da",
    "#00bcd4",
    "#00acc1",
    "#0097a7",
    "#00838f",
    "#006064",
    "#84ffff",
    "#18ffff",
    "#00e5ff",
    "#00b8d4",
    "#e0f2f1",
    "#b2dfdb",
    "#80cbc4",
    "#4db6ac",
    "#26a69a",
    "#009688",
    "#00897b",
    "#00796b",
    "#00695c",
    "#004d40",
    "#a7ffeb",
    "#64ffda",
    "#1de9b6",
    "#00bfa5",
    "#e8f5e9",
    "#c8e6c9",
    "#a5d6a7",
    "#81c784",
    "#66bb6a",
    "#4caf50",
    "#43a047",
    "#388e3c",
    "#2e7d32",
    "#1b5e20",
    "#b9f6ca",
    "#69f0ae",
    "#00e676",
    "#00c853",
    "#f1f8e9",
    "#dcedc8",
    "#c5e1a5",
    "#aed581",
    "#9ccc65",
    "#8bc34a",
    "#7cb342",
    "#689f38",
    "#558b2f",
    "#33691e",
    "#ccff90",
    "#b2ff59",
    "#76ff03",
    "#64dd17",
    "#f9fbe7",
    "#f0f4c3",
    "#e6ee9c",
    "#dce775",
    "#d4e157",
    "#cddc39",
    "#c0ca33",
    "#afb42b",
    "#9e9d24",
    "#827717",
    "#f4ff81",
    "#eeff41",
    "#c6ff00",
    "#aeea00",
    "#fffde7",
    "#fff9c4",
    "#fff59d",
    "#fff176",
    "#ffee58",
    "#ffeb3b",
    "#fdd835",
    "#fbc02d",
    "#f9a825",
    "#f57f17",
    "#ffff8d",
    "#ffff00",
    "#ffea00",
    "#ffd600",
    "#fff8e1",
    "#ffecb3",
    "#ffe082",
    "#ffd54f",
    "#ffca28",
    "#ffc107",
    "#ffb300",
    "#ffa000",
    "#ff8f00",
    "#ff6f00",
    "#ffe57f",
    "#ffd740",
    "#ffc400",
    "#ffab00",
    "#fff3e0",
    "#ffe0b2",
    "#ffcc80",
    "#ffb74d",
    "#ffa726",
    "#ff9800",
    "#fb8c00",
    "#f57c00",
    "#ef6c00",
    "#e65100",
    "#ffd180",
    "#ffab40",
    "#ff9100",
    "#ff6d00",
    "#fbe9e7",
    "#ffccbc",
    "#ffab91",
    "#ff8a65",
    "#ff7043",
    "#ff5722",
    "#f4511e",
    "#e64a19",
    "#d84315",
    "#bf360c",
    "#ff9e80",
    "#ff6e40",
    "#ff3d00",
    "#dd2c00",
    "#efebe9",
    "#d7ccc8",
    "#bcaaa4",
    "#a1887f",
    "#8d6e63",
    "#795548",
    "#6d4c41",
    "#5d4037",
    "#4e342e",
    "#3e2723",
    "#fafafa",
    "#f5f5f5",
    "#eeeeee",
    "#e0e0e0",
    "#bdbdbd",
    "#9e9e9e",
    "#757575",
    "#616161",
    "#424242",
    "#212121",
    "#eceff1",
    "#cfd8dc",
    "#b0bec5",
    "#90a4ae",
    "#78909c",
    "#607d8b",
    "#546e7a",
    "#455a64",
    "#37474f",
    "#263238"
  ];
  public static Effects = [
    { id: 0, name: "Change XP",required:true },
    { id: 1, name: "Change Hitpoints", required: true },
    { id: 2, name: "Change Powerpoints", required: true },
    { id: 3, name: "Full Hitpoints" },
    { id: 4, name: "Full Powerpoints" },
    { id: 5, name: "Full HP & PP" }

  ];
  public static FovSettings = [
    { id: "", value: "Disabled" },
    { id: "5", value: "Dark (5)" },
    { id: "10", value: "Shadowy (10)" },
    { id: "15", value: "Dim Light (15)" },
    { id: "25", value: "Full Light (25)" },
    { id: "skill", value: "Based on Skill" }


  ];
  public static Assets = {
    global: [
      { id: "grid", name: "Grid", path: "assets/imgs/scene/grid.png", block: false, view: false },
      { id: "tourmeeple", name: "TourMeeple", path: "assets/imgs/scene/tourmeeple.png", block: false, view: true },
    ],
    floor: [
      { id: "floor", name: "Floor", path: "floor.png", block: true, view: true, state: -1, state1: "", stateb: 0 },
      { id: "wall", name: "Wall", path: "wall.png", block: true, view: false, state: -1, state1: "", stateb: 0 },
      { id: "door", name: "Door", path: "door.png", block: true, view: false, state: 0, state1: "door-open.png", stateb: 0 },
      { id: "doubledoor", name: "Double door", path: "double-door.png", block: true, view: false,state:0,state1:"door-open.png",stateb:0 },
      { id: "dooropen", name: "Open door", path: "door-open.png", block: false, view: true, state: 0, state1: "door.png", stateb: 0 },
      { id: "doorlocked", name: "Locked door", path: "door-locked.png", block: false, view: false, state: 0, state1: "door-open.png", stateb: 1 },
      { id: "doorsecret", name: "Secret door", path: "door-secret.png", block: false, view: true, state: -1, state1: "", stateb: 0 },
      { id: "window", name: "Window", path: "window.png", block: false, view: true, state: -1, state1: "", stateb: 0 },
      { id: "porticullis", name: "Porticullis/Gate", path: "porticullis.png", block: false, view: true, state: 0, state1: "door-open.png", stateb: 0 },
      { id: "statue", name: "Statue", path: "statue.png", block: false, view: true, state: -1, state1: "", stateb: 0 },
      { id: "well", name: "Well", path: "well.png", block: false, view: true, state: -1, state1: "", stateb: 0 },
      { id: "chair", name: "Chair / Throne", path: "chair.png", block: false, view: true, state: -1, state1: "", stateb: 0 },
      { id: "altar", name: "Altar", path: "altar.png", block: false, view: true, state: -1, state1: "", stateb: 0 },
      { id: "stairs", name: "Stairs", path: "stairs.png", block: false, view: true, state: -1, state1: "", stateb: 0 },
      { id: "pit", name: "Pit", path: "pit.png", block: false, view: true , state: -1, state1: "", stateb: 0 },
      { id: "chest", name: "Chest", path: "chest.png", block: false, view: true, state: -1, state1: "", stateb: 0 }

     
    ],
    objects: [
      { id: "ra-player",group:"persons" },
      { id: "ra-double-team", group: "persons" },
      { id: "ra-monster-skull", group: "persons" },
      { id: "ra-flask",group: "potions" },
      { id: "ra-vase", group: "persons" },
      { id: "ra-vial", group: "persons" },
      { id: "ra-vial", group: "persons" },
      { id: "ra-ammo-bag", group: "inventory" },
      { id: "ra-book", group: "inventory" },
      { id: "ra-candle", group: "inventory" },
      { id: "ra-crown", group: "inventory" },
      { id: "ra-key", group: "inventory" },
      { id: "ra-key-basic", group: "inventory" },
      { id: "ra-wrench", group: "inventory" },
      { id: "ra-medical-pack", group: "inventory" },
      { id: "ra-pills", group: "inventory" },
      { id: "ra-potion", group: "inventory" },
      { id: "ra-quill-ink", group: "inventory" },
      { id: "ra-rune-stone", group: "inventory" },
      { id: "ra-sheriff", group: "inventory" },
      { id: "ra-ship-emblem", group: "inventory" },
      { id: "ra-shotgun-shell", group: "inventory" },
      { id: "ra-syringe", group: "inventory" },
      { id: "ra-torch", group: "inventory" },
      { id: "ra-trophy", group: "inventory" },
      { id: "ra-wooden-sign", group: "inventory" },
      { id: "ra-beetle", group: "creatures" },
      { id: "ra-bird-claw", group: "creatures" },
      { id: "ra-cat", group: "creatures" },
      { id: "ra-dinosaur", group: "creatures" },
      { id: "ra-dragon", group: "creatures" },
      { id: "ra-dragon", group: "creatures" },
      { id: "ra-dragonfly", group: "creatures" },
      { id: "ra-eye-monster", group: "creatures" },
      { id: "ra-fairy", group: "creatures" },
      { id: "ra-fish", group: "creatures" },
      { id: "ra-fox", group: "creatures" },
      { id: "ra-gecko", group: "creatures" },
      { id: "ra-hydra", group: "creatures" },
      { id: "ra-insect-jaws", group: "creatures" },
      { id: "ra-lion", group: "creatures" },
      { id: "ra-maggot", group: "creatures" },
      { id: "ra-octopus", group: "creatures" },
      { id: "ra-rabbit", group: "creatures" },
      { id: "ra-raven", group: "creatures" },
      { id: "ra-sea-serpent", group: "creatures" },
      { id: "ra-seagull", group: "creatures" },
      { id: "ra-sheep", group: "creatures" },
      { id: "ra-snail", group: "creatures" },
      { id: "ra-snake", group: "creatures" },
      { id: "ra-spider-face", group: "creatures" },
      { id: "ra-spiked-tentacle", group: "creatures" },
      { id: "ra-suckered-tentacle", group: "creatures" },
      { id: "ra-tentacle", group: "creatures" },
      { id: "ra-two-dragons", group: "creatures" },
      { id: "ra-venomous-snake", group: "creatures" },
      { id: "ra-wyvern", group: "creatures" },
      { id: "ra-wolf-head", group: "creatures" },
      { id: "ra-dragon", group: "creatures" },
      { id: "ra-batteries", group: "electronics" },
      { id: "ra-clockwork", group: "electronics" },
      { id: "ra-cog", group: "electronics" },
      { id: "ra-cog-wheel", group: "electronics" },
      { id: "ra-gears", group: "electronics" },
      { id: "ra-laser-site", group: "electronics" },
      { id: "ra-lever", group: "electronics" },
      { id: "ra-light-bulb", group: "electronics" },
      { id: "ra-radar-dish", group: "electronics" },
      { id: "ra-radioactive", group: "electronics" },
      { id: "ra-reactor", group: "electronics" },
      { id: "ra-regeneration", group: "electronics" },
      { id: "ra-repair", group: "electronics" },
      { id: "ra-robot-arm", group: "electronics" },
      { id: "ra-speech-bubble", group: "electronics" },
      { id: "ra-surveillance-camera", group: "electronics" },
      { id: "ra-acorn", group: "food" },
      { id: "ra-apple", group: "food" },
      { id: "ra-beer", group: "food" },
      { id: "ra-brandy-bottle", group: "food" },
      { id: "ra-carrot", group: "food" },
      { id: "ra-cheese", group: "food" },
      { id: "ra-chicken-leg", group: "food" },
      { id: "ra-coffee-mug", group: "food" },
      { id: "ra-crab-claw", group: "food" },
      { id: "ra-egg", group: "food" },
      { id: "ra-honeycomb", group: "food" },
      { id: "ra-knife-fork", group: "food" },
      { id: "ra-meat", group: "food" },
      { id: "ra-roast-chicken", group: "food" },
      { id: "ra-toast", group: "food" },
      { id: "ra-daisy", group: "plants" },
      { id: "ra-dead-tree", group: "plants" },
      { id: "ra-flowers", group: "plants" },
      { id: "ra-grass", group: "plants" },
      { id: "ra-grass-patch", group: "plants" },
      { id: "ra-pine-tree", group: "plants" },
      { id: "ra-super-mushroom", group: "plants" },
      { id: "ra-acid", group: "dangers" },
      { id: "ra-biohazard", group: "dangers" },
      { id: "ra-blade-bite", group: "dangers" },
      { id: "ra-blast", group: "dangers" },
      { id: "ra-blaster", group: "dangers" },
      { id: "ra-bleeding-eye", group: "dangers" },
      { id: "ra-bone-bite", group: "dangers" },
      { id: "ra-fire", group: "dangers" },
      { id: "ra-tombstone", group: "dangers" },
      { id: "ra-crystal-ball", group: "magic" },
      { id: "ra-crystal-cluster", group: "magic" },
      { id: "ra-crystal-wand", group: "magic" },
      { id: "ra-crystals", group: "magic" },
      { id: "ra-diamond", group: "magic" },
      { id: "ra-droplet", group: "magic" },
      { id: "ra-emerald", group: "magic" },
      { id: "ra-fire-ring", group: "magic" },
      { id: "ra-flame-symbol", group: "magic" },
      { id: "ra-frost-emblem", group: "magic" },
      { id: "ra-gem", group: "magic" },
      { id: "ra-gem-pendant", group: "magic" },
      { id: "ra-gold-bar", group: "magic" },
      { id: "ra-health", group: "magic" },
      { id: "ra-hot-surface", group: "magic" },
      { id: "ra-lava", group: "magic" },
      { id: "ra-sapphire", group: "magic" },
      { id: "ra-small-fire", group: "magic" },
      { id: "ra-sun", group: "magic" },
      { id: "ra-water-drop", group: "magic" },
      { id: "ra-acid", group: "magic" },
      { id: "ra-arcane-mask", group: "equipment" },
      { id: "ra-anvil", group: "equipment" },
      { id: "ra-archer", group: "equipment" },
      { id: "ra-archery-target", group: "equipment" },
      { id: "ra-arrow-cluster", group: "equipment" },
      { id: "ra-axe", group: "equipment" },
      { id: "ra-barrier", group: "equipment" },
      { id: "ra-battered-axe", group: "equipment" },
      { id: "ra-bear-trap", group: "equipment" },
      { id: "ra-bombs", group: "equipment" },
      { id: "ra-bone-knife", group: "equipment" },
      { id: "ra-bowie-knife", group: "equipment" },
      { id: "ra-bullets", group: "equipment" },
      { id: "ra-chain", group: "equipment" },
      { id: "ra-cluster-bomb", group: "equipment" },
      { id: "ra-cracked-helm", group: "equipment" },
      { id: "ra-cracked-shield", group: "equipment" },
      { id: "ra-croc-sword", group: "equipment" },
      { id: "ra-crossbow", group: "equipment" },
      { id: "ra-crossed-axes", group: "equipment" },
      { id: "ra-crossed-pistols", group: "equipment" },
      { id: "ra-crossed-sabers", group: "equipment" },
      { id: "ra-crossed-swords", group: "equipment" },
      { id: "ra-daggers", group: "equipment" },
      { id: "ra-fire-shield", group: "equipment" },
      { id: "ra-flaming-claw", group: "equipment" },
      { id: "ra-flat-hammer", group: "equipment" },
      { id: "ra-gavel", group: "equipment" },
      { id: "ra-gear-hammer", group: "equipment" },
      { id: "ra-grappling-hook", group: "equipment" },
      { id: "ra-grenade", group: "equipment" },
      { id: "ra-helmet", group: "equipment" },
      { id: "ra-horns", group: "equipment" },
      { id: "ra-heavy-shield", group: "equipment" },
      { id: "ra-knight-helmet", group: "equipment" },
      { id: "ra-mp5", group: "equipment" },
      { id: "ra-musket", group: "equipment" },
      { id: "ra-revolver", group: "equipment" },
      { id: "ra-rifle", group: "equipment" },
      { id: "ra-round-shield", group: "equipment" },
      { id: "ra-scythe", group: "equipment" },
      { id: "ra-shield", group: "equipment" },
      { id: "ra-shuriken", group: "equipment" },
      { id: "ra-spiked-mace", group: "equipment" },
      { id: "ra-sword", group: "equipment" },
      { id: "ra-trident", group: "equipment" },
      { id: "ra-vest", group: "equipment" },
      { id: "ra-anvil", group: "equipment" },
      { id: "ra-ankh", group: "general" },
      { id: "ra-anchor", group: "general" },
      { id: "ra-batwings", group: "general" },
      { id: "ra-bell", group: "general" },
      { id: "ra-bird-mask", group: "general" },
      { id: "ra-broken-skull", group: "general" },
      { id: "ra-campfire", group: "general" },
      { id: "ra-castle-emblem", group: "general" },
      { id: "ra-cubes", group: "general" },
      { id: "ra-death-skull", group: "general" },
      { id: "ra-desert-skull", group: "general" },
      { id: "ra-fedora", group: "general" },
      { id: "ra-hand", group: "general" },
      { id: "ra-hand-emblem", group: "general" },
      { id: "ra-help", group: "general" },
      { id: "ra-hive-emblem", group: "general" },
      { id: "ra-hole-ladder", group: "general" },
      { id: "ra-hood", group: "general" },
      { id: "ra-interdiction", group: "general" },
      { id: "ra-metal-gate", group: "general" },
      { id: "ra-pawprint", group: "general" },
      { id: "ra-scroll-unfurled", group: "general" },
      { id: "ra-skull", group: "general" },
      { id: "ra-skull-trophy", group: "general" },
      { id: "ra-x-mark", group: "general" },

    ]
  };

  public static doRoll(game,value, powerpoint = false) {

    var val = value;
    if (powerpoint) {
      val += 1;
    }
    return GlobalServiceProvider.Roll(game.dice.outcomes, game.dice.sides, val);
  }

  public static RollDice(dice,val) {

      var result = [];
      switch (dice.setting)
      {
          case "Icons":
              result = GlobalServiceProvider.Roll(dice.outcomes, dice.sides, val);
              break;
          case "Numbers":
              result = GlobalServiceProvider.RollNumbers(dice.sides, val);
              break;
          case "Dice pool":
              result = GlobalServiceProvider.RollPool(dice.sides,0, val);
              break;
          default:
              result = GlobalServiceProvider.Roll(dice.outcomes, dice.sides, val);
              break;
      }

      return result;
      
  }
  public static CalculateSuccesses(roll,pool)
  {
    return roll.filter(e => { return e >= pool }).length;
  }
  public static RollPool(sides,pool, val) {
      var result = [];
      if (pool > 0) {
          var total = 0
          for (var i = 0; i < val; i++) {
              var r = (Math.floor(Math.random() * Math.floor(sides)) + 1);
              if (r >= pool) {
                  total++;
              }
          }
          result.push(total);
      }
      else
      {
          for (var i = 0; i < val; i++) {
              var r = (Math.floor(Math.random() * Math.floor(sides)) + 1);
              result.push(r);
          }
      }
      return result;
  }
  public static RollNumbers(sides,val)
  {
      var result = [];
      result.push((Math.floor(Math.random() * Math.floor(sides))+1)+val);
      return result;
  }
  public static Roll(outcomes, sides, value) {
    var roller = [];
    for (var i = 0; i < outcomes.length; i++) {
      for (var x = 0; x < outcomes[i].sides; x++) {
        roller.push(outcomes[i].icon);
      }
    }
    if (roller.length < sides) {
      for (var i = roller.length; i < sides; i++) {
        roller.push("");
      }
    }



    var result = [];
    for (var i = 0; i < value; i++) {
      var idx = Math.floor(Math.random() * Math.floor(roller.length));
      result.push(roller[idx]);
    }

    return result;
  }

  public static RollNewStyle(skill=0,att=0,dice1,dice2,usedice2=false,pp=0,skillname="",attname="") {

    var amountdice1 = 0;
    var amountdice2 = 0;

    if (skill > 0) {
      if (dice1.statpool) { amountdice1 = skill; }
      if (!dice1.statpool) { amountdice1 = dice1.fixed; }
      if (pp > 0) amountdice1 += pp;
    }

    if (usedice2) {
      if (dice2.statpool) { amountdice2 = att; }
      if (!dice2.statpool) { amountdice2 = dice2.fixed; }
    }
    else {
      if (att > 0) {

      }
    }
    /*
    if (dice1.settings == "Icons") {
      if (usedice2) { }
      else {
        
      }
    }
    */

  }

  public static GetServerImage(image, folder,def ) {

    if ((image == null || image == '') && def != '') {
      return def;
    }
    else {
      if (folder != "") {
        return GlobalServiceProvider.ImageUrl + "" + folder + "/" + image;
      }
      else {
        return image;
      }
    }

  }
  private static  GUID4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  public static GUID() {

    // then to call it, plus stitch in '4' in the third group
    return (this.GUID4() + this.GUID4() + "-" + this.GUID4() + "-4" + this.GUID4().substr(0, 3) + "-" + this.GUID4() + "-" + this.GUID4() + this.GUID4() + this.GUID4()).toLowerCase();
  }

  constructor(public http: HttpClient) {
    console.log('Hello GlobalServiceProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/global-service/global-service.ts